import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { format } from 'date-fns';
import api from '../api';
import Nav from '../components/Nav';
import Chat from '../components/Chat';

function ThoughtView() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [topic, setTopic] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get(`/public/topics/${id}`)
      .then(({ data }) => setTopic(data.topic))
      .catch(() => setTopic(null))
      .finally(() => setLoading(false));
  }, [id]);

  if (loading) return <div className="loading">...</div>;

  if (!topic) return (
    <div>
      <Nav active="thoughts" />
      <div className="page">
        <div className="empty">
          <h2>Thought not found</h2>
          <button className="btn btn-soft" onClick={() => navigate('/thoughts')}>Back</button>
        </div>
      </div>
    </div>
  );

  return (
    <div>
      <Nav active="thoughts" />
      <div className="page">
        <article className="entry-page">
          {topic.category && (
            <div className="entry-date-big" style={{ color: 'var(--sage)' }}>
              {topic.category}
            </div>
          )}
          <h1 style={{ fontFamily: 'var(--font-serif)', fontSize: '2rem', fontWeight: 400, textAlign: 'center', marginBottom: '12px' }}>
            {topic.title}
          </h1>
          <div className="entry-date-big">
            {format(new Date(topic.created_at), 'MMMM d, yyyy')}
          </div>

          <div className="day-meta" style={{ justifyContent: 'center', marginBottom: '40px' }}>
            {topic.mood && <span className="badge badge-mood">{topic.mood}</span>}
            {topic.tags && topic.tags.map(t => (
              <span key={t} className="badge badge-tag">#{t}</span>
            ))}
          </div>

          <div className="entry-content-full">{topic.content}</div>

          <div className="entry-footer">
            <button className="btn btn-ghost" onClick={() => navigate('/thoughts')}>
              &larr; All thoughts
            </button>
          </div>
        </article>
      </div>
      <Chat contextType="topic" contextId={parseInt(id)} />
    </div>
  );
}

export default ThoughtView;
